import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../../core/navigation.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../../core/security/user.service';
import { LeftPanelService } from '../../../../../layout/home/services/left-panel.service';
import { environment } from '../../../../../../environments/environment';
import { DatePickerConfigService } from '../../../../../shared/components/datepicker/datepicker-config.service';
import { CoreServiceRegistry } from '../../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../../shared/shared-service-registry';
import { FullViewImgViewerPopupComponent } from './full-view-img-viewer/full-view-img-viewer.component';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { LoaderEnabled } from '../../../../../shared/components/loader/loader.service';

@Component({
  selector: 'lfwms-commodity-search',
  templateUrl: './commodity-skuImage-accordian.component.html',
  styleUrls: ['./commodity-skuImage-accordian.component.css']
})
export class  CommoditySkuImageAccordianComponent extends AbstractFormWidgetComponent implements AfterViewInit {

  public imgUrlArray: Array<any> = [];
  public index: number = 0;
  public currentImgUrl: string = '';
  public showImgViewer: boolean = false;
  public http$: HttpClient;

  ngAfterViewInit() {
    const storerKey: string = this.cellDataMap['storerKey'].cVal;
    const commodity: string = this.cellDataMap['sku'].cVal;
    this.getImageUrl(storerKey, commodity).subscribe((response) => {
       this.imgUrlArray = response['results'] ? response['results'] : [];
    });
  }
  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService,
    protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
      super(resourceService, navService, leftPanelService,
        alertService, userService, dateConfigService);
        this.http$ = coreServiceRegistry.http$;
    }

    public openImgInFullView(index: number) {
      this.currentImgUrl = this.imgUrlArray[index]['ImageURL'];
      this.index = index;
      this.showImgViewer = this.currentImgUrl ? true : false;
    }

    /**
     * navigate To Next Or Previous Image
     */
    public navigateToNextOrPreviousImage(nextOrPrevious: string) {
        this.index = nextOrPrevious === 'next' ?  this.index + 1 : this.index - 1;
        this.currentImgUrl = this.imgUrlArray[this.index]['ImageURL'];
    }


    @LoaderEnabled()
    public getImageUrl(storerKey: string, commodity: string): Observable<any> {
      const response$ = this.http$.get(`api/sku/images/` + storerKey + '/' + commodity)
        .map((response: any) => {
          return response;
        })
        .catch((error: any) => {
          if (error.error.length !== 0) {
            if (error.error.statusCode !== 200) {
              return Observable.throw(error.error.statusMessage);
            }
          }
        });
      return response$;
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/setup/customer/commodity/commodity-skuImage-accordian/commodity-skuImage-accordian.component.ts